import React from 'react';
import DangKyHoSoUpdate from '../../../containers/KVC/DangKyHoSo/DangKyHoSoUpdate';


export default function DangKiHoSo() {
	return <DangKyHoSoUpdate />
}
